import React, { useEffect, useState, useRef } from "react";
import { EmailValidation } from "../Validation/EmailValidation";
import { toast } from "react-toastify";
import {
  useKycEmailOtpMutation,
  useKycEmailVerifyMutation,
  useKycAddPhoneMutation,
} from "../../redux/kycApi";

import { parsePhoneNumberFromString } from "libphonenumber-js";

// phone-input-2
import "react-phone-input-2/lib/bootstrap.css";
import PhoneInput from "react-phone-input-2";

const Personal = ({ kycTrack, refetch, mode = "email" }) => {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [countryCode, setCountryCode] = useState("in");

  const [verification_code, setVerification_code] = useState("");
  const [counter, setCounter] = useState(0);
  const [timerText, setTimerText] = useState("");
  const [textForCode, setTextForCode] = useState("Get Code");

  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [codeError, setCodeError] = useState("");

  const [codeVerifyStatus, setCodeVerifyStatus] = useState(false);
  const [codeBtnDisable, setCodeBtnDisable] = useState(false);
  const [codeInputDisable, setCodeInputDisable] = useState(true);
  const [submitBtnDisable, setSubmitBtnDisable] = useState(false);

  const [kycEmailOtp] = useKycEmailOtpMutation();
  const [kycEmailVerify] = useKycEmailVerifyMutation();
  const [kycAddPhone] = useKycAddPhoneMutation();

  const timerRef = useRef(null);

  console.log(mode, "mode");

  // INITIAL PREFILL
  useEffect(() => {
    if (mode === "phone") {
      const storedPhone = kycTrack?.progress?.phone_verification?.data || "";
      const storedCode = kycTrack?.country_code || "";
      if (storedPhone && storedCode) {
        const codeDigits = storedCode.startsWith("+")
          ? storedCode.slice(1)
          : storedCode;
        if (storedPhone.startsWith(codeDigits)) {
          setPhone(storedPhone);
        } else {
          setPhone(`${codeDigits}${storedPhone}`);
        }
      } else {
        setPhone(storedPhone || "");
      }
    } else {
      setEmail(kycTrack?.progress?.email_verification?.data || "");
    }
  }, [kycTrack, mode]);

  // ----------- VALIDATION ENGINE ---------------

  const validateMobile = (value) => {
    if (!value) return "This field is required";

    const parsed = parsePhoneNumberFromString(`+${value}`);
    if (!parsed || !parsed.isValid()) {
      return "Invalid phone number";
    }

    return "";
  };

  const validateEmailField = (value) => {
    let validation = EmailValidation("email", value);

    if (value && value.includes("@")) {
      const [local] = value.split("@");
      if (local.length < 2) {
        validation = "Email must have at least 2 characters before '@'";
      }
    }

    return validation;
  };

  // ----------- HANDLE INPUT CHANGE -------------

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "email") {
      const lowerValue = value.toLowerCase();
      setEmail(lowerValue);

      const err = validateEmailField(lowerValue);
      setEmailError(err);
      setCodeInputDisable(!!err);
      setVerification_code("");
      setTextForCode("Get Code");
    } else if (name === "verification_code") {
      setVerification_code(value);
      setCodeError(value ? "" : "This field is required");
    }
  };

  // ----------- COUNTDOWN ------------------------

  const startCountdown = (seconds) => {
    let counter = seconds;

    timerRef.current = setInterval(() => {
      setCounter(counter);
      setCodeBtnDisable(true);
      setTimerText("Resend In");

      counter--;

      if (counter < 0) {
        clearInterval(timerRef.current);
        setCounter(0);
        setTimerText("");
        setCodeBtnDisable(false);
        setTextForCode("Resend Code");
      }
    }, 1000);
  };

  // ----------- GET CODE -------------------------

  const getCode = async () => {
    if (mode === "email") {
      const err = validateEmailField(email);
      if (err) {
        setEmailError(err);
        return;
      }
    } else {
      const err = validateMobile(phone);
      if (err) {
        setPhoneError(err);
        return;
      }
    }

    setCodeBtnDisable(true);

    const payload = {
      type: mode, // 👈 NEW REQUIRED PARAM
      email: mode === "email" ? email : undefined,
      phone: mode === "phone" ? `+${phone}` : undefined,
    };

    const { data, error } = await kycEmailOtp(payload);

    if (error) {
      toast.error(error?.data?.message || "Failed to send OTP");
      setTimeout(() => setCodeBtnDisable(false), 2000);
      return;
    }

    if (data?.status) {
      setCodeError("");
      setCodeInputDisable(false);
      startCountdown(30);
      toast.success(data?.EmailMessage || data?.message || "OTP sent");
    } else {
      toast.error(data?.message || "Something went wrong");
      setTimeout(() => setCodeBtnDisable(false), 2000);
    }
  };

  // ----------- SUBMIT ----------------------------

  const handleSubmit = async () => {
    if (mode === "email" && !email) {
      setEmailError("This field is required");
      return;
    }
    if (mode === "phone" && !phone) {
      setPhoneError("This field is required");
      return;
    }
    if (mode === "email" && !verification_code) {
      setCodeError("This field is required");
      return;
    }

    if (emailError || phoneError || codeError) return;

    setSubmitBtnDisable(true);
    setTimeout(() => setSubmitBtnDisable(false), 2000);

    if (mode === "phone") {
      const err = validateMobile(phone);
      if (err) {
        setPhoneError(err);
        return;
      }

      const parsed = parsePhoneNumberFromString(`+${phone}`);
      if (!parsed) {
        setPhoneError("Invalid phone number");
        return;
      }

      const { data, error } = await kycAddPhone({
        phone: parsed.nationalNumber,
        country_code: `+${parsed.countryCallingCode}`,
      });

      if (error) {
        toast.error(error?.data?.message || "Phone update failed");
        return;
      }

      if (data?.status) {
        toast.success(data.message || "Phone updated successfully");
        refetch();
      } else {
        toast.error(data?.message || "Phone update failed");
      }
      return;
    }

    const payload = {
      type: mode, // 👈 NEW REQUIRED PARAM
      email: mode === "email" ? email : undefined,
      otp: verification_code || "000000",
    };

    const { data, error } = await kycEmailVerify(payload);

    if (error) {
      toast.error(error?.data?.message || "Verification failed");
      return;
    }

    if (data?.status) {
      if (!codeVerifyStatus) {
        toast.success(data.message || "Verified successfully");
        setCodeVerifyStatus(true);
      }
      setCodeInputDisable(true);
      refetch();
    } else {
      toast.error(data?.message || "Invalid OTP");
    }
  };

  // ----------- UI RENDER -------------------------

  return (
    <div className="personal-outer">
      <div className="align-items-top">
        <div className="">
          <div className="white_box">
            <h6 className="position-relative">
              {mode === "phone" ? "Phone" : "Email"} Verification
            </h6>
            <p>
              Fill in your personal information the way it is stated in the
              proof of identity document you submit
            </p>
            <form>
              <div className="row">
                {/* INPUT FIELD */}
                <div className="form-group col-md-6">
                  <label>
                    {mode === "phone" ? "Phone Number" : "Email Address"}
                  </label>

                  {mode === "phone" ? (
                    <PhoneInput
                      country={countryCode}
                      value={phone}
                      onChange={(val, data) => {
                        setPhone(val);
                        setCountryCode(data?.countryCode);
                        const err = validateMobile(val);
                        setPhoneError(err);
                        setCodeInputDisable(!!err);
                      }}
                      disableDropdown={false}
                      inputClass="form-control"
                      buttonClass=""
                      containerClass=""
                      disabled={kycTrack?.progress?.phone_verification?.data}
                    />
                  ) : (
                    <input
                      type="text"
                      className="form-control"
                      name="email"
                      placeholder="Enter Email Address"
                      maxLength="70"
                      value={email}
                      disabled={kycTrack?.progress?.email_verification?.data}
                      onChange={handleChange}
                    />
                  )}

                  {mode === "email" && emailError && (
                    <div className="text-danger">{emailError}</div>
                  )}
                  {mode === "phone" && phoneError && (
                    <div className="text-danger">{phoneError}</div>
                  )}
                </div>

                {/* OTP FIELD */}
                {mode === "email" &&
                  kycTrack?.progress?.email_verification?.status ===
                    "pending" && (
                    <div className="form-group col-md-6">
                      <label>Verification Code</label>
                      <div className="input-group-prepend">
                        <input
                          type="number"
                          className="form-control"
                          name="verification_code"
                          placeholder="Enter Verification Code"
                          maxLength="20"
                          value={verification_code}
                          onChange={handleChange}
                          disabled={codeInputDisable}
                        />
                        <button
                          className="btn btn_man"
                          type="button"
                          onClick={getCode}
                          disabled={codeBtnDisable}
                        >
                          {timerText} {counter === 0 ? textForCode : counter}
                        </button>
                      </div>
                      {codeError && (
                        <div className="text-danger">{codeError}</div>
                      )}
                    </div>
                  )}
              </div>

              {/* SUBMIT BUTTON */}
              {(mode === "phone"
                ? kycTrack?.progress?.phone_verification?.status === "pending"
                : kycTrack?.progress?.email_verification?.status ===
                  "pending") && (
                <button
                  className="btn btn_man fs12"
                  type="button"
                  onClick={handleSubmit}
                  disabled={submitBtnDisable}
                >
                  Submit
                </button>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Personal;
